import { ComplexEnum } from '../../utils/complexEnum'
import { Lot, Test } from './instances'

export type LotCompactionLevelItem = typeof Lot | typeof Test

class LotCompactionLevelEnum extends ComplexEnum<
  'LotCompactionLevel',
  LotCompactionLevelItem,
  LotCompactionLevelItem['id']
> {
  readonly typename = 'LotCompactionLevel'
  get values() {
    return [this.Lot, this.Test]
  }
  readonly Lot = Lot
  readonly Test = Test
}

export const LotCompactionLevel = new LotCompactionLevelEnum()
